
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lpVqo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bb133feace827f75$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $bb133feace827f75$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': "P\xe1gina sem t\xedtulo",
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "Crie uma p\xe1gina nova para inserir como link",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': "Criar p\xe1gina do Confluence",
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Abrir no Confluence',
    'editorExtensionLinkCreate.confluencePage.successFlag.description': "A p\xe1gina foi criada",
    'editorExtensionLinkCreate.confluencePage.successFlag.title': "P\xe1gina criada",
    'editorExtensionLinkCreate.confluencePage.title': "Criar nova p\xe1gina",
    'editorExtensionLinkCreate.genericError.description': "Atualize a p\xe1gina e tente outra vez.",
    'editorExtensionLinkCreate.genericError.title': 'Algo deu errado',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Crie um item em linha e insira o item como link',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Criar item no Jira',
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Abrir no Jira',
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'O item foi criado',
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Item criado',
    'editorExtensionLinkCreate.jiraIssue.title': 'Criar item novo',
    'editorExtensionLinkCreate.keyword.create': 'criar',
    'editorExtensionLinkCreate.keyword.issue': 'item',
    'editorExtensionLinkCreate.keyword.new': 'novo',
    'editorExtensionLinkCreate.keyword.page': "p\xe1gina",
    'editorExtensionLinkCreate.keyword.publish': 'publicar',
    'editorExtensionLinkCreate.keyword.raise': 'criar',
    'editorExtensionLinkCreate.keyword.space': "espa\xe7o",
    'editorExtensionLinkCreate.keyword.ticket': 'ticket'
};

});


//# sourceMappingURL=pt_BR.f1f04425.js.map
